import React from 'react';
import { motion } from 'framer-motion';
import { Thermometer, Zap, Ruler } from 'lucide-react';
const metrics = [{
  icon: Thermometer,
  title: 'Temperatura Basal',
  description: 'Tu metabolismo se refleja en tu temperatura matutina. Objetivo: 36.5-36.8°C',
  color: 'text-red-500',
  bg: 'bg-red-50'
}, {
  icon: Zap,
  title: 'Nivel de Energía',
  description: 'Medimos tu energía diaria en una escala del 1-10. El verdadero indicador de salud metabólica.',
  color: 'text-yellow-500',
  bg: 'bg-yellow-50'
}, {
  icon: Ruler,
  title: 'Contorno Abdominal',
  description: 'La cinta métrica no miente. Medimos centímetros perdidos, no solo kilos.',
  color: 'text-blue-500',
  bg: 'bg-blue-50'
}];
export function BioFeedbackSection() {
  return <section className="py-24 bg-white" data-id="element-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-14">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1F2937] mb-4" data-id="element-15">
            Olvídate de la Báscula: Mide tu Progreso Real
          </h2>
          <p className="text-lg text-[#6B7280]" data-id="element-16">
            El peso no cuenta toda la historia. Usamos indicadores científicos
            que realmente importan.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-17">
          {metrics.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl border border-gray-200 flex flex-col items-center text-center" data-id="element-18">
              <div className={`w-16 h-16 ${item.bg} rounded-2xl flex items-center justify-center mb-6 ${item.color}`} data-id="element-19">
                <item.icon size={32} strokeWidth={2} data-id="element-20" />
              </div>

              <h3 className="text-xl font-bold text-[#1F2937] mb-3" data-id="element-21">
                {item.title}
              </h3>
              <p className="text-[#6B7280] leading-relaxed" data-id="element-22">
                {item.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}